// extracted by mini-css-extract-plugin
export default {"contecntCl":"Content_contecntCl__cPysW","loader":"Content_loader__Qot3w"};